import { render, staticRenderFns } from "./DangerShipList.vue?vue&type=template&id=5f53af28&scoped=true"
import script from "./DangerShipList.vue?vue&type=script&lang=js"
export * from "./DangerShipList.vue?vue&type=script&lang=js"
import style0 from "./DangerShipList.vue?vue&type=style&index=0&id=5f53af28&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f53af28",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f53af28')) {
      api.createRecord('5f53af28', component.options)
    } else {
      api.reload('5f53af28', component.options)
    }
    module.hot.accept("./DangerShipList.vue?vue&type=template&id=5f53af28&scoped=true", function () {
      api.rerender('5f53af28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/DangerShipList.vue"
export default component.exports